import { render, staticRenderFns } from "./IconClipboardListOutline.vue?vue&type=template&id=8f60fc36"
import script from "./IconClipboardListOutline.vue?vue&type=script&lang=js"
export * from "./IconClipboardListOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports